import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './routes';
import { provideAnimations } from '@angular/platform-browser/animations';

import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { AuthInterceptor, SpinnerInterceptor } from '@http/interceptors';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

export const appConfig: ApplicationConfig = {
    providers: 
    [
        {
            provide: HTTP_INTERCEPTORS, 
            useClass: AuthInterceptor, 
            multi: true 
        },
        { 
            provide: HTTP_INTERCEPTORS, 
            useClass: SpinnerInterceptor, 
            multi: true },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, 
            useValue: {
                appearance: 'outline'
            }
        },
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS, 
            useValue: {
                hasBackdrop: true,
                maxWidth: "420px",
            }
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideRouter(routes), 
        provideAnimations(),
    ]
};
